<div class="row mb-2">
  <div class="col py-0">
    <div class="row">
      <div class="col py-0">
        @if (unconfirmedTicket?.urgent) {
          <h1>
            <b class="text-danger">URGENTE!!!</b>
          </h1>
        }
        <b>Resumo:</b>
      </div>
      <div class="col-12 py-0 mb-0">
        @if (unconfirmedTicket) {
          <span style="white-space: pre-line">{{ unconfirmedTicket.summary }}</span>
        }
      </div>
    </div>
  </div>
  <div class="col-auto pr-0">
    @if (isSprintCanWrite()) {
      <patron-button
        type="button"
        color="secondary"
        [iconName]="loadingLogs ? 'pi-spinner' : 'pi-clock'"
        (click)="dataService.openTicketLogsModalEmitter.emit(undefined)">
        Apontamentos
        @if (openedLogs && openedLogs.length) {
          <div>
            @for (log of openedLogs; track log) {
              <patron-badge color="danger">
                {{ log.user?.name }}
              </patron-badge>
            }
          </div>
        }
      </patron-button>
    }
  </div>
</div>
